import type { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'

export type SingleSeries = Awaited<
  ReturnType<typeof MembershipsCreatorV2ApiClient.getSingleSeries>
>['data']

export enum FormFields {
  title = 'title',
  description = 'description',
  coverImage = 'coverImage',
  coverImageResourceId = 'coverImageResourceId',
  thumbnailImage = 'thumbnailImage',
  thumbnailImageResourceId = 'thumbnailImageResourceId',
}

export type FormValues = {
  [FormFields.title]: string
  [FormFields.description]?: string
  [FormFields.coverImage]?: string
  [FormFields.coverImageResourceId]?: number
  [FormFields.thumbnailImage]?: string
  [FormFields.thumbnailImageResourceId]?: number
}
